import Glide from '@glidejs/glide';

function equalizeSlideHeights(el) {
  const slides = Array.from(el.querySelectorAll('.home-banner__slide'));
  if (!slides.length) {
    return;
  }

  slides.forEach((slide) => {
    slide.style.minHeight = '';
  });

  const maxHeight = slides.reduce((max, slide) => Math.max(max, slide.offsetHeight), 0);

  slides.forEach((slide) => {
    slide.style.minHeight = `${maxHeight}px`;
  });
}

function init(el) {
  const updateHeights = () => equalizeSlideHeights(el);

  if (el.classList.contains('home-banner__slider--single')) {
    updateHeights();
    return;
  }

  const carousel = new Glide(el, {
    type: 'carousel',
    perView: 1,
    gap: 0,
    animationDuration: 600,
  });

  carousel.on('mount.after', updateHeights);
  carousel.on('resize', updateHeights);
  carousel.mount();
  updateHeights();
}

export default function() {
  const sliders = Array.from(document.querySelectorAll('.js-home-banner'));
  if (!sliders.length) {
    return;
  }
  sliders.forEach(slider => init(slider));
}
